// Generated by ReScript, PLEASE EDIT WITH CARE

import * as React from "react";
import * as Router from "common/src/Router.bs.js";
import * as Belt_Array from "rescript/lib/es6/belt_Array.js";
import * as Translation from "common/src/bindings/Translation.bs.js";
import * as ContentSection from "common/src/ContentSection.bs.js";
import Tab from "@mui/material/Tab";
import Tabs from "@mui/material/Tabs";

function WrappedNav(Props) {
  var set = Props.set;
  var t = Translation.useT(/* Common */0);
  var router = Router.use(undefined);
  var value;
  if (set >= 110) {
    value = set >= 141 ? (
        set !== 150 ? (
            set !== 160 ? (
                set !== 170 ? "10" : "17"
              ) : "16"
          ) : "15"
      ) : (
        set >= 121 ? (
            set !== 130 ? (
                set >= 140 ? "14" : "10"
              ) : "13"
          ) : (
            set >= 111 ? (
                set >= 120 ? "12" : "10"
              ) : "11"
          )
      );
  } else if (set >= 47) {
    if (set !== 56) {
      if (set >= 90) {
        if (set >= 102) {
          value = "10";
        } else {
          switch (set) {
            case 90 :
                value = "9";
                break;
            case 95 :
                value = "9.5";
                break;
            case 91 :
            case 92 :
            case 93 :
            case 94 :
            case 96 :
            case 97 :
            case 98 :
            case 99 :
            case 100 :
            case 101 :
                value = "10";
                break;
            
          }
        }
      } else {
        value = set !== 76 ? "10" : "7.5";
      }
    } else {
      value = "5.5";
    }
  } else {
    value = set !== 10 ? (
        set !== 36 ? (
            set >= 46 ? "4.5" : "10"
          ) : "3.5"
      ) : "10";
  }
  return React.createElement(ContentSection.make, {
              className: "mb-8 px-3 pt-2 max-w-[100vw]",
              children: React.createElement(Tabs, {
                    variant: "scrollable",
                    children: Belt_Array.map([
                          "11",
                          "12",
                          "13",
                          "14",
                          "15",
                          "16",
                          "17"
                        ], (function (tab) {
                            return React.createElement(Tab, {
                                        label: t("Set #").replace("#", tab),
                                        value: tab,
                                        key: tab
                                      });
                          })),
                    value: value,
                    onChange: (function (v1, v2) {
                        switch (v2) {
                          case "10" :
                              return router.push("/wrapped/set-10", undefined, undefined);
                          case "11" :
                              return router.push("/wrapped/set-11", undefined, undefined);
                          case "12" :
                              return router.push("/wrapped/set-12", undefined, undefined);
                          case "13" :
                              return router.push("/wrapped/set-13", undefined, undefined);
                          case "14" :
                              return router.push("/wrapped/set-14", undefined, undefined);
                          case "15" :
                              return router.push("/wrapped/set-15", undefined, undefined);
                          case "16" :
                              return router.push("/wrapped/set-16", undefined, undefined);
                          case "17" :
                              return router.push("/wrapped/set-17", undefined, undefined);
                          case "4.5" :
                              return router.push("/wrapped/set-46", undefined, undefined);
                          case "5.5" :
                              return router.push("/wrapped/set-56", undefined, undefined);
                          case "7.5" :
                              return router.push("/wrapped/set-76", undefined, undefined);
                          default:
                            return ;
                        }
                      })
                  }),
              noPadding: true
            });
}

var make = WrappedNav;

export {
  make ,
  
}
/* react Not a pure module */
